import React, {
    useContext,
    createContext,
    useState,
    useMemo,
} from "react";
import TokenExpireModal from "../components/modal/token-expire";

const WebContext = createContext()

const useWebDetail = () => {
    const {
        webDetail,
        setWebDetail,
    } = useContext(WebContext)
    return {
        webDetail,
        setWebDetail,
    }
}
//==============================
const useWebBackOfficeLineLoginSuccess = () => {
    const {
        webBackOfficeLineLoginSuccess,
        setWebBackOfficeLineLoginSuccess,
    } = useContext(WebContext)
    return {
        webBackOfficeLineLoginSuccess,
        setWebBackOfficeLineLoginSuccess,
    }
}
const useLineDetail = () => {
    const {
        lineDetail,
        setLineDetail,
    } = useContext(WebContext)
    return {
        lineDetail,
        setLineDetail,
    }
}
//==============================
const useOpenModalTokenExpired = () => {
    const {
        openModalTokenExpired,
        setOpenModalTokenExpired,
    } = useContext(WebContext)
    return {
        openModalTokenExpired,
        setOpenModalTokenExpired,
    }
}

const WebProvider = ({ children }) => {
    const [webDetail, setWebDetail] = useState({});
    const [webBackOfficeLineLoginSuccess, setWebBackOfficeLineLoginSuccess] = useState(false);
    const [lineDetail, setLineDetail] = useState(null);
    const [openModalTokenExpired, setOpenModalTokenExpired] = useState(false);
    //==============================
    const ModalTokenExpired = useMemo(() => {
        return (
            <TokenExpireModal open={openModalTokenExpired} />
        );
    }, [openModalTokenExpired]);

    return (
        <WebContext.Provider value={{
            webDetail,
            setWebDetail,
            webBackOfficeLineLoginSuccess,
            setWebBackOfficeLineLoginSuccess,
            lineDetail,
            setLineDetail,
            openModalTokenExpired,
            setOpenModalTokenExpired,    
        }}>
            {children}
            {ModalTokenExpired}
        </WebContext.Provider>
    )
};

export {
    WebProvider,
    useWebDetail,
    useWebBackOfficeLineLoginSuccess,
    useLineDetail,
    useOpenModalTokenExpired,
};